<footer class="footer">
  <div class="contain">
    <div class="d-flex justify-content-between">
      <div class="flex-item-layout">

        <div class="d-flex align-items-center">
          <div class="me-3">
            <div>
              <a id="ctiaImgLink" href="{{links.CTIAImage}}" target="_blank"><img id="ctiaImg"
                  src="assets/images/footer-ctia-logo.svg" alt="ctia - footer logo" typeof="foaf:Image"></a>
            </div>
          </div>
          <div>
            <div>
              <a id="iconectivImgLink" href="{{links.IconectivImage}}" target="_blank"><img id="iconectivImg"
                  src="assets/images/iconectiv.png" alt="iconectiv - Footer Logo" typeof="foaf:Image"></a>
            </div>
          </div>
        </div>
        <p>
          The Short Code Registry is a service mark of CTIA. iconectiv® is a registered trademark of iconectiv, LLC.
        </p>

      </div>
      <div class="flex-item-layout">
        <ul>
          <li>
            &nbsp;
            <a class="white" href="{{links.AcceptableUsePolicy}}">Acceptable Use Policy</a>
          </li>
          &nbsp;
          <li>
            &nbsp;
            <a class="white" href="{{links.PrivacyPolicy}}">Privacy Policy</a>
          </li>
          &nbsp;
          <li>
            &nbsp;
            <a class="white" href="{{links.RegSubLicenseAgreement}}">Registrant Sublicense Agreement</a>
          </li>
          &nbsp;
          <li>
            &nbsp;
            <a class="white" href="{{links.TermsOfUse}}" target="_blank">Terms of Use</a>
          </li>
        </ul>
        <div>
          <p class="footer-copyright">© {{year}} CTIA. All Rights Reserved.</p>
        </div>
      </div>
      <div class="flex-item-layout">
        <button (click)="jumpToTop()" class="btn">
          <i class="far fa-circle-up to-top-icon"></i>
        </button>
      </div>
    </div>
  </div>
</footer>